import { useMembershipStore } from '@space-shell/core/store'

export default function useOptionalShowcase() {
  const { membershipData } = useMembershipStore()
  const showcaseEnabled = membershipData?.showcase ?? true

  return {
    showcaseEnabled
  }
}
